module.exports = __webpack_public_path__ + "img/wu.238714d8.png";